import React from "react";
import { Award, ShieldCheck, Download, Linkedin } from "lucide-react";
import { API } from "@/lib/api";

export default function CertificateCard({ certificate }) {
  if (!certificate) {
    return <p className="text-sm text-slate-400 text-center py-6" data-testid="portfolio-no-certificate">No certificate earned yet. Complete the 30-day challenge to unlock one.</p>;
  }
  const verifyUrl = certificate.verification_url;
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=140x140&margin=8&data=${encodeURIComponent(verifyUrl)}`;
  const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(verifyUrl)}`;

  return (
    <div className="glass-panel rounded-2xl p-6 border border-[#FBBF24]/25 flex flex-col sm:flex-row items-center gap-6" data-testid="portfolio-certificate-card">
      <img src={qrUrl} alt="Certificate verification QR code" loading="lazy" className="w-28 h-28 rounded-lg bg-white p-1.5 shrink-0" data-testid="certificate-qr-code" />
      <div className="flex-1 text-center sm:text-left">
        <div className="flex items-center gap-2 justify-center sm:justify-start">
          <Award className="w-5 h-5 text-[#FBBF24]" />
          <p className="font-heading font-semibold text-white">30-Day Data Cloud Challenge Certificate</p>
        </div>
        <p className="text-xs text-slate-400 mt-1">Certificate ID: <span className="text-slate-300 font-mono">{certificate.certificate_id}</span> · Score: {certificate.score}%</p>
        <p className="text-xs text-slate-400">Issued {new Date(certificate.issued_at).toLocaleDateString()}</p>
        <div className="flex items-center flex-wrap gap-2 mt-3 justify-center sm:justify-start">
          <a href={verifyUrl} target="_blank" rel="noreferrer" data-testid="certificate-verify-link" className="flex items-center gap-1.5 text-xs font-semibold bg-white/5 hover:bg-white/10 text-slate-300 px-3 py-2 rounded-lg">
            <ShieldCheck className="w-3.5 h-3.5" /> Verify
          </a>
          <a href={`${API}/certificate/${certificate.certificate_id}/pdf`} data-testid="certificate-download-link" className="flex items-center gap-1.5 text-xs font-semibold bg-white/5 hover:bg-white/10 text-slate-300 px-3 py-2 rounded-lg">
            <Download className="w-3.5 h-3.5" /> Download PDF
          </a>
          <a href={linkedInShareUrl} target="_blank" rel="noreferrer" data-testid="certificate-linkedin-share-btn" className="flex items-center gap-1.5 text-xs font-semibold bg-[#0A66C2]/15 hover:bg-[#0A66C2]/25 text-[#5DA1F1] px-3 py-2 rounded-lg">
            <Linkedin className="w-3.5 h-3.5" /> Share on LinkedIn
          </a>
        </div>
      </div>
    </div>
  );
}
